module.exports = __webpack_public_path__ + "img/25+1_食道胃十二指腸簡圖.84ef76ee.png";